<!-- DApp小卡片，展示图标、名字、描述 -->

<template>
  <a class="dapp-block" @click="handleClick">
    <!--<div class="aspect" data-ratio="16:9">-->
    <div class="dapp-block-content box-shadow">

      <!--<div class="image-wrapper aspect" data-ratio="8:3">-->
      <SimpleImage class="dapp-block-image" :src="dapp.picture" :placeholder="require('../static/rectangle-gray.png')"/>
      <!--</div>-->

      <div class="dapp-block-text">
        <p class="dapp-block-name">{{ dapp.name }}</p>
        <p v-if="description" class="dapp-block-description two-lines">{{ description }}</p>
      </div>

    </div>
    <!--</div>-->
  </a>
</template>

<script>
  import SimpleImage from './SimpleImage'
  import * as router from '../router'

  export default {
    name: 'DAppCard',
    components: {SimpleImage},
    props: ['dapp'],
    data () {
      return {}
    },
    computed: {
      description () {
        const desc = this.dapp && this.dapp.description
        if (desc) {
          let number = 100
          if (desc.length > number) {
            return desc.substr(0, number) + '...'
          } else {
            return desc
          }
        }
        return null
      }
    },
    methods: {
      handleClick () {
        router.navigateToDApp(this.dapp)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dapp-block {
    display: block;
    height: 100%;
    width: 100%;
  }

  .dapp-block-content {
    height: 100%;
    width: 100%;
    background: white;
    display: flex;
    flex-direction: column;
  }

  /*.image-wrapper {*/
  /*overflow: hidden;*/
  /*}*/

  .dapp-block-image {
    width: 100%;
    height: auto;
    overflow: hidden;
  }

  .dapp-block-text {
    padding: 10px 15px 15px 15px;
  }

  .dapp-block-name {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
    margin: 0;
    font-weight: bold;
  }

  .dapp-block-description {
    overflow: hidden;
    text-overflow: ellipsis;
    max-lines: 1;
    padding: 0;
    margin: 8px 0 0 0;
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppCard.vue